import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { ButtonType } from '../../enum/button-type.enum';
import { InputSize } from '../../enum/input-size.enum';
import {
  NgxFloatUiContentComponent,
  NgxFloatUiDirective,
  NgxFloatUiPlacements,
  NgxFloatUiTriggers,
} from 'ngx-float-ui';
import { DropdownItem } from '../../form/models/dropdown-item';
import { MatIcon } from '@angular/material/icon';
import { GeneralStatusPillComponent } from '../../pills/general-status-pill/general-status-pill.component';

@Component({
  selector: 'lib-button-dropdown',
  imports: [ButtonComponent, NgxFloatUiContentComponent, NgxFloatUiDirective, MatIcon, GeneralStatusPillComponent],
  templateUrl: './button-dropdown.component.html',
  styleUrl: './button-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonDropdownComponent<T> {
  type = input<ButtonType>(ButtonType.primary);
  size = input<InputSize>(InputSize.large);
  leadingIconName = input<string | null | undefined>();
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  selectedValue = input<unknown | null>();
  dropdownItems = input<DropdownItem<T>[]>([]);
  clearable = input<boolean>(false);
  fullWidth = input<boolean>(false);
  alignRight = input<boolean>(false);
  itemSelected = output<DropdownItem<T> | null>();
  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;
  protected readonly NgxFloatUiPlacements = NgxFloatUiPlacements;
  protected readonly NgxFloatUiTriggers = NgxFloatUiTriggers;

  dropdownItemClicked(dropdownItem: DropdownItem<T> | null) {
    this.itemSelected.emit(dropdownItem);
  }
}
